// These constants are used for requests to the local web server

import {
  FUNDSSERVICES_REPORTING_BASE_PATH,
  FUNDSSERVICES_SECURITY_BASE_PATH,
} from 'src/app/constants/NextGenConstants';

// Reports metadata
export const REPORT_TYPES_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/metadata/report-types`;
export const FOOTER_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/metadata/legal-footer`;

// Activity
export const ACT_USER_TEMPLATE_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/activity/user-template`;
export const ACT_FILTER_OPTIONS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/activity/filter-options`;
export const ACT_DASHBOARD_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/activity/dashboard`;
export const ACT_TOP_PERFORMERS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/activity/top-performers`;
export const ACT_EXPORTS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/activity/exports`;

// Benchmark
export const BENCHMARK_FILTER_OPTIONS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/benchmark/filter-options`;
export const BENCHMARK_GET_USER_TEMPLATE_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/benchmark/template`;
export const BENCHMARK_USER_TEMPLATE_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/benchmark/user-template`;
export const BENCHMARK_DASHBOARD_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/benchmark/dashboard`;
export const BENCHMARK_TOP_PERFORMERS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/benchmark/top-performers`;
export const BENCHMARK_EXPORTS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/benchmark/summary`;

// Reports
export const DEFUALT_TEMPLATE_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/default-template`;
export const TEMPLATE_NAMES_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/templates`;
export const REPORT_DATE_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/report-date`;
export const PW_ETF_CUSIPS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/cusips`;
export const PW_ETF_MRNGSTR_ASSETS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/morningstar-assets`;
export const PW_ETF_MRNGSTR_CATGRS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/morningstar-categories`;
export const FILTER_OPTIONS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/filter-options`;
export const TEMPLATE_COLUMNS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/template-columns`;
export const TEMPLATE_COLUMNS_PATH_SORTING = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/template-columns-sorting`;
export const TEMPLATE_FILTER_VALUES_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/templates/filter-values`;
export const VIEW_REPORTS_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports`;
export const DOWNLOAD_REPORT_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/download`;

export const RUN_REPORT_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/run-report`;

// V2 Reports
export const V2_TEMPLATE_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/reports/v2/template`;
export const REPORT_TYPES_BASE_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/report-types`;

// Common
export const LEGAL_DISCLOSURE_PATH = `${FUNDSSERVICES_REPORTING_BASE_PATH}/common/legal-disclosure`;

// Security
export const SECURITY_POLICIES_PATH = `${FUNDSSERVICES_SECURITY_BASE_PATH}/policies`;
export const CSRF_PATH = `${FUNDSSERVICES_SECURITY_BASE_PATH}/csrf`;

export const FORTRESS_SALES_REPORTING = 'SALES REPORTING';
export const FORTRESS_CREATE_REPORTS = 'CREATE REPORTS';
export const FORTRESS_ACTIVITY_DASHBOARD = 'ACTIVITY DASHBOARD';
export const FORTRESS_BENCHMARK_DASHBOARD = 'BENCHMARK DASHBOARD';
export const FORTRESS_SALES_REPORTING_REGEX = new RegExp(
  `^${FORTRESS_SALES_REPORTING}\\.?`,
);

export const FUND_FAMILY_SUPER_GROUP_EMPTY = '';
export const CHANNEL_EMPTY = '';
